import { useMemo } from 'react';

import { useCageController_Status } from '@/services/hooks';
import type { CageStatus } from '@/services/types';

import type { DomainQueryOptions } from '../shared/types';

import { mapCageStatusToDomain } from './mappers';
import type { UseGetCageStatusResult } from './types';

export const useGetCageStatus = (
    cageId: number,
    options?: DomainQueryOptions<CageStatus>
): UseGetCageStatusResult => {
    const statusQuery = useCageController_Status(cageId, options);

    const cageStatus = useMemo(() => {
        if (!statusQuery.data?.data) {
            return null;
        }
        return mapCageStatusToDomain(statusQuery.data.data);
    }, [statusQuery.data?.data]);

    return {
        ...statusQuery,
        isLoading: statusQuery.isPending,
        data: cageStatus,
    };
};
